export default __webpack_public_path__ + "7aa81974cc66bb11113ce131bf43e923.png";